export default __webpack_public_path__ + "static/media/client6.c718d3d5.png";